import { render, staticRenderFns } from "./ViewAcademySurvey.vue?vue&type=template&id=3b5674df&scoped=true"
import script from "./ViewAcademySurvey.vue?vue&type=script&lang=js"
export * from "./ViewAcademySurvey.vue?vue&type=script&lang=js"
import style0 from "./ViewAcademySurvey.vue?vue&type=style&index=0&id=3b5674df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5674df",
  null
  
)

export default component.exports